import { render, staticRenderFns } from "./delivery-notification-grid.vue?vue&type=template&id=370acc82"
import script from "./delivery-notification-grid.vue?vue&type=script&lang=js"
export * from "./delivery-notification-grid.vue?vue&type=script&lang=js"
import style0 from "./delivery-notification-grid.vue?vue&type=style&index=0&id=370acc82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports